import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SidebarState {
	/** Mobile: sidebar visible or hidden */
	isOpen: boolean;
	/** Desktop: collapsed to icon rail (48px) or expanded (208px) */
	isCollapsed: boolean;
	/** Pinned/favorite nav items (paths) */
	favorites: string[];
	toggle: () => void;
	setOpen: (open: boolean) => void;
	toggleCollapse: () => void;
	setCollapsed: (collapsed: boolean) => void;
	addFavorite: (path: string) => void;
	removeFavorite: (path: string) => void;
}

export const useSidebarStore = create<SidebarState>()(
	persist(
		(set) => ({
			isOpen: true,
			isCollapsed: false,
			favorites: [],
			toggle: () => set((s) => ({ isOpen: !s.isOpen })),
			setOpen: (open) => set({ isOpen: open }),
			toggleCollapse: () => set((s) => ({ isCollapsed: !s.isCollapsed })),
			setCollapsed: (collapsed) => set({ isCollapsed: collapsed }),
			addFavorite: (path) =>
				set((s) => ({
					favorites: s.favorites.includes(path)
						? s.favorites
						: [...s.favorites, path],
				})),
			removeFavorite: (path) =>
				set((s) => ({
					favorites: s.favorites.filter((f) => f !== path),
				})),
		}),
		{
			name: "omnios-sidebar",
			partialize: (s) => ({
				isOpen: s.isOpen,
				isCollapsed: s.isCollapsed,
				favorites: s.favorites,
			}),
		},
	),
);
